import clsx from 'clsx'
import BestListCard from '../ui/BestListCard'
import { FC, ReactNode, useState } from 'react'
import { BasicStyledComponent, DSBest } from 'shared-definitions/types'
import styles from './AltBestCards.module.css'
import RWButton from '../buttons/RWButton'

interface AltBestCardsProps extends BasicStyledComponent {
  cards: DSBest[]
  showMoreLabel: string
  /** A row under each card's buttons (`BestListCard` `footerSlot`); null for none on that card. */
  cardFooterSlot?: (card: DSBest) => ReactNode
}

const AltBestCards: FC<AltBestCardsProps> = ({
  className,
  cards,
  showMoreLabel,
  cardFooterSlot,
}) => {
  const [visibleCards, setVisibleCards] = useState(6)
  const hasMore = cards.length > visibleCards

  return (
    <div className={clsx(className, styles.container)}>
      {cards.map((item, index) => (
        <BestListCard
          key={index}
          card={item}
          footerSlot={cardFooterSlot?.(item)}
          className={clsx({
            [styles.hidden]: index >= visibleCards,
          })}
        />
      ))}
      {hasMore && (
        <RWButton
          className={styles.showMore}
          variant="tertiary"
          size="medium"
          onClick={() => setVisibleCards(s => s + 3)}
        >
          {showMoreLabel}
        </RWButton>
      )}
    </div>
  )
}

export default AltBestCards
